import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { useLocation } from "react-router";
import AuthenticationService from "../../services/AuthenticationService";
import CountryContext from "../../CountryContext";

const PrivateRoute = ({
  component: Component,
  scopes: pageScopes,
  ...rest
}) => {
  const { pathname } = useLocation();
  const { country } = useContext(CountryContext);

  if (!AuthenticationService.isUserAuthenticated()) {
    return (
      <Redirect
        to={{ pathname: `/${country.code}`, state: { from: pathname } }}
      />
    );
  }

  const scopes = AuthenticationService.getUserScopes();

  if (pageScopes && !pageScopes.some((r) => scopes.indexOf(r) >= 0)) {
    return (
      <Redirect
        to={{ pathname: `/${country.code}/home`, state: { from: pathname } }}
      />
    );
  }

  return <Route {...rest} component={Component} />;
};

export default PrivateRoute;
